import { types } from "../types/types";

const initialState = {
  initialBalance: {},
};

export const initialBalanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.initialBalanceSidebar:
      return {
        ...state,
        initialBalance: { ...action.payload },
      };
    case types.authLogout:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
